import React from 'react';
import PropTypes from 'prop-types';

import { useI18n } from '@hydra/common/components/i18n';
import CriteriumSocialSection from '@hydra/common/criterium/CriteriumSocialSection';
import Criterium from '@hydra/common/criterium/Criterium';

export const Crunchbase = ({ criterium }) => {
  const { moment } = useI18n();
  const { data, url } = criterium;
  const {
    detected,
    imageUrl,
    permalink,
    name,
    description,
    city,
    updatedAt
  } = data;

  const content = (
    <CriteriumSocialSection
      isDetected={detected}
      network='Crunchbase'
      image={imageUrl}
      sections={[
        { name: 'crunchbase_url', node: permalink },
        { name: 'crunchbase_name', node: name },
        { name: 'crunchbase_description', node: description },
        { name: 'crunchbase_city', node: city },
        { name: 'crunchbase_updated', node: updatedAt && moment(new Date(updatedAt * 1000)).fromNow() }
      ]}
    />
  );

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url, crunchbasePermalink: permalink }}
    >
      {content}
    </Criterium>
  );
};

Crunchbase.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.object
  })
};

export default React.memo(Crunchbase);
